import { useState } from 'react';
import { Button, useCanAccess, useListContext } from 'react-admin';
import { Edit } from '@mui/icons-material';
import BulkUpdateCategoryDialog from './Dialog';

export default function BulkUpdateCategoryButton() {
  const { selectedIds } = useListContext();
  const mappingRulesWriteAccess = useCanAccess({ resource: 'mapping_rules', action: 'write' });
  const categoryListAccess = useCanAccess({ resource: 'categories', action: 'list' });

  const [dialogOpen, setDialogOpen] = useState(false);

  if (!mappingRulesWriteAccess.canAccess || !categoryListAccess.canAccess) {
    return false;
  }

  return (
    <>
      <Button
        label="Map to category"
        onClick={() => setDialogOpen(true)}
        disabled={selectedIds.length <= 0}
      >
        <Edit />
      </Button>
      <BulkUpdateCategoryDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
    </>
  );
}
